// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScanPage from './pages/ScanPage';
import About from "./pages/About";

function App() {
  return (
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<ScanPage />} />
          <Route path="/About" element={<About />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;